export default __webpack_public_path__ + "static/media/vc.4dc0cdc5.svg";